/* ==========================================================================
   Custom cookie banner — riorganizzazione DOM Shopify Customer Privacy
   Fix loop infinito: NIENTE observer su attributes (setProperty su style
   triggerava il callback che riapplicava setProperty → loop).
   Solo childList/subtree per rilevare il banner iniettato asincronamente.
   Guard con data-pub-styled per non riprocessare.
   ========================================================================== */
(function () {
  'use strict';

  function findButtons(banner) {
    var accept = null, decline = null, manage = null;
    banner.querySelectorAll('button, a').forEach(function (el) {
      if (accept && decline && manage) return;
      var txt = (el.textContent || '').toLowerCase().trim();
      var isAcc = el.matches('.shopify-pc__banner__btn-accept, [data-track="accept"], .shopify-pc__banner__btn--primary');
      var isDec = el.matches('.shopify-pc__banner__btn-decline, [data-track="decline"], .shopify-pc__banner__btn--secondary');
      var isMan = el.matches('.shopify-pc__banner__btn-manage, .shopify-pc__banner__manage, [href*="preferences"], [data-track*="preferences"]');

      if (!accept && (isAcc || txt === 'accetta' || txt === 'accept')) { accept = el; return; }
      if (!decline && (isDec || txt === 'declina' || txt === 'rifiuta' || txt === 'decline')) { decline = el; return; }
      if (!manage && (isMan || txt.indexOf('gestisci') > -1 || txt.indexOf('preferenze') > -1)) { manage = el; return; }
    });
    return { accept: accept, decline: decline, manage: manage };
  }

  function setImp(el, prop, val) {
    if (el && el.style) el.style.setProperty(prop, val, 'important');
  }

  function styleBanner(banner) {
    if (!banner) return;
    // GUARD FORTE: se già processato, esci subito
    if (banner.dataset.pubStyled === '1') return;

    var btns = findButtons(banner);
    if (!btns.accept || !btns.decline) return;

    var dialog = banner.querySelector('.shopify-pc__banner__dialog') || btns.accept.parentElement;
    if (!dialog) return;

    // Se esiste già un wrapper, saltiamo (mai riprocessare)
    if (dialog.querySelector('.pub-pc__actions')) {
      banner.dataset.pubStyled = '1';
      return;
    }

    // Crea wrapper e sposta i 3 elementi dentro
    var wrapper = document.createElement('div');
    wrapper.className = 'pub-pc__actions';

    wrapper.appendChild(btns.decline);
    wrapper.appendChild(btns.accept);
    if (btns.manage) wrapper.appendChild(btns.manage);
    dialog.appendChild(wrapper);

    // Applica inline styles UNA SOLA VOLTA
    setImp(wrapper, 'display', 'flex');
    setImp(wrapper, 'flex-direction', 'row');
    setImp(wrapper, 'flex-wrap', 'wrap');
    setImp(wrapper, 'gap', '10px');
    setImp(wrapper, 'margin-top', '14px');
    setImp(wrapper, 'width', '100%');
    setImp(wrapper, 'align-items', 'stretch');

    setImp(btns.decline, 'flex', '1 1 calc(50% - 5px)');
    setImp(btns.decline, 'min-width', '0');
    setImp(btns.decline, 'width', 'auto');
    setImp(btns.decline, 'order', '1');
    setImp(btns.decline, 'margin', '0');

    setImp(btns.accept, 'flex', '1 1 calc(50% - 5px)');
    setImp(btns.accept, 'min-width', '0');
    setImp(btns.accept, 'width', 'auto');
    setImp(btns.accept, 'order', '2');
    setImp(btns.accept, 'margin', '0');

    if (btns.manage) {
      setImp(btns.manage, 'flex', '1 1 100%');
      setImp(btns.manage, 'flex-basis', '100%');
      setImp(btns.manage, 'width', '100%');
      setImp(btns.manage, 'order', '3');
      setImp(btns.manage, 'text-align', 'center');
      setImp(btns.manage, 'margin', '4px 0 0');
      setImp(btns.manage, 'display', 'block');
    }

    banner.dataset.pubStyled = '1';
  }

  function findAndStyle() {
    document.querySelectorAll('#shopify-pc__banner, .shopify-pc__banner').forEach(styleBanner);
  }

  function init() {
    findAndStyle();

    // MutationObserver SOLO su childList/subtree per detect banner iniettato.
    // NO attributes: eviterebbe loop con setProperty su style.
    var obs = new MutationObserver(function (mutations) {
      // Ottimizzazione: verifichiamo se una mutation potrebbe aver iniettato un banner
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1 && (n.id === 'shopify-pc__banner' || (n.classList && n.classList.contains('shopify-pc__banner')) || n.querySelector && n.querySelector('#shopify-pc__banner, .shopify-pc__banner'))) {
            findAndStyle();
            return;
          }
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });

    // Polling backup MOLTO limitato: 5 tentativi × 500ms = 2.5s solo per pagine
    // dove il banner appare con ritardo. Poi STOP definitivo.
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      findAndStyle();
      if (attempts >= 5) clearInterval(poll);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
